/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserRewards } from '../../models/user-rewards';

export interface GetLoyaltyUserRewards$Params {
  'Active-Tenant-Identifier': string;
  userId: string;
  time?: string;
}

export function getLoyaltyUserRewards(http: HttpClient, rootUrl: string, params: GetLoyaltyUserRewards$Params, context?: HttpContext): Observable<StrictHttpResponse<UserRewards>> {
  const rb = new RequestBuilder(rootUrl, getLoyaltyUserRewards.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('userId', params.userId, {});
    rb.header('time', params.time, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserRewards>;
    })
  );
}

getLoyaltyUserRewards.PATH = '/loyalty/users/{userId}/rewards';
